module.exports = {
      id: "breaking-news-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#breaking-news",
      toString: function () {
        return this.url;
      }
    }